import { render, staticRenderFns } from "./venderainfo.vue?vue&type=template&id=5e3a19c3&scoped=true&"
import script from "./venderainfo.vue?vue&type=script&lang=js&"
export * from "./venderainfo.vue?vue&type=script&lang=js&"
import style0 from "./venderainfo.vue?vue&type=style&index=0&id=5e3a19c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a19c3",
  null
  
)

export default component.exports